{
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "name": "Username",
    "email": "Account",
    "login": "Log in",
    "password": "Password",
    "old_password": "Old Password",
    "new_password": "New Password",
    "repeat_new_password": "Repeat New Password",
    "recover_password": "Recover password",
    "update_password": "Update Password",
    "at_least_8_long": "Must be at least 8 characters long",
    "at_least_6_unique": "Must contain at least 6 unique characters",
    "passwords_do_not_match": "Passwords do not match",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password",
    "open_dashboard": "Open Dashboard",
    "welcome": "Welcome to",
    "error_401": "Invalid username or password"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar",
    "home": "Home",
    "member_since": "Member since"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "form": {
    "must": "This field is required",
    "valid_email": "Please enter a valid account"
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Billing",
    "login": "Login",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "user_panel": "User Panel",
    "admin_panel": "Admin Panel",
    "overview": "Overview",
    "experiment_design": "Experiment Design",
    "admin_experiment_design": "Experiment Design Management",
    "users": "Users",
    "projects": "Projects",
    "quartet": "Quartet",
    "plasmix": "Plasmix",
    "dna": "Genomics",
    "rna": "Transcriptomics",
    "protein": "Proteomics",
    "metabolism": "Metabolism",
    "plasmix_protein": "Proteomics",
    "plasmix_metabolism": "Metabolism"
  },
  "design": {
    "project_name": "Project Name",
    "sample_type": "Sample Type",
    "sample_count": "Clinical Sample Count",
    "omics_type": "Omics Type",
    "reference_count": "Reference Material Count",
    "reference_type": "Reference Material Type",
    "created_at": "Created At",
    "status": "Status",
    "submitted": "Submitted",
    "cancelled": "Cancelled",
    "confirmed": "Confirmed"
  },
  "omics": {
    "add_item": "Add Item",
    "get_report": "Get Report",
    "download": "Download",
    "uploading": "Uploading",
    "cancel": "Cancel",
    "save": "Save",
    "add": "add",
    "upload_hint": "Please add or modify the item after uploading the raw data to ",
    "aliyun": "Aliyun",
    "upload_hint_2": ". ",
    "aliyun_path": "OSS Path",
    "download_report": "Download QC Report",
    "confirm_download": "Are you sure you want to download QC report? It may take a few seconds to generate the report.",
    "confirm_download_with_name": "Are you sure you want to download QC report for {name}? It may take a few seconds to generate the report.",
    "confirm_form_change_disregard": "Form has unsaved changes. Are you sure you want to close it?",
    "csv_only": "Only .csv files are accepted",
    "refer_sample": "click here for the samples",
    "qc_result": "QC Result",
    "filter_by_user": "Filter by User",
    "notes": "Notes",
    "update_notes": "Update Notes",
    "confirm_update_notes": "Are you sure you want to update the notes for {name}?",
    "download_raw_data": "Download Raw Data",
    "confirm_download_raw_data": "Are you sure you want to download raw data {file} for {name}?",
    "sample_number": "Sample Number",
    "created_at": "Created At",
    "yes": "Yes",
    "no": "No",
    "pass": "Pass QC",
    "fail": "QC Failed"
  },
  "dna": {
    "edit_data": "Edit DNA Data",
    "add_data": "Add DNA Data",
    "view_data": "View DNA Data",
    "name": "Name",
    "name_placeholder": "Input Name",
    "sample_id": "Sample ID",
    "family": "Family",
    "platform_model": "Platform & Model",
    "dna_fragmentation": "DNA Fragmentation",
    "library_protocol": "Library Protocol",
    "application": "Application",
    "read_mode": "Read Mode",
    "reference": "Reference",
    "alignment_software": "Aligement Software",
    "variant_caller": "Variant Caller",
    "filtering": "Filtering",
    "determinated_at": "Sequencing Date",
    "vcf_file": "VCF File",
    "d5": "D5(Twin Daughter 1)",
    "d6": "D6(Twin Daughter 2)",
    "f7": "F7(Father)",
    "m8": "M8(Mother)",
    "acoustic_shear": "Acoustic Shear",
    "enzymatic": "Enzymatic",
    "transposase": "Transposase",
    "no_fragmentation": "No Fragmentation",
    "pcr_free": "PCR-free",
    "pcr_based": "PCR-based",
    "hybrid_capture": "Hybrid Capture",
    "wgs": "WGS",
    "wes": "WES",
    "targeted_panel": "Targeted Panel",
    "low_pass_wgs": "Low-pass WGS",
    "status": "Status",
    "processing": "Processing",
    "done": "Done",
    "select_hint": "Selected items(click to unselect)",
    "upload_hint": "It would qc VCF first, and automatically qc FASTQ if VCF failed. The according report can be downloaded afterwards.",
    "vcf_only": "Only .vcf and .vcf.gz files are accepted. Both INDEL and SNP markers are needed and SV markers are not validated by far",
    "fq_only": "Only .fq.gz format is accepted",
    "plz_select": "Please select ",
    "uploading": "Uploading",
    "uploaded": "Uploaded",
    "upload_failure": "Fail to upload, please refresh the page and continue",
    "vcf_pass": "VCF QC Passed",
    "download_vcf": "Download VCF File",
    "confirm_download": "Are you sure you want to download VCF file({file})s?",
    "update_score": "Update Score",
    "confirm_update_score": "Are you sure you want to update the score for {name}?"
  },
  "rna": {
    "edit_data": "Edit RNA Data",
    "add_data": "Add RNA Data",
    "view_data": "View RNA Data",
    "name": "Name",
    "sample_id": "Sample ID",
    "platform_model": "Platform & Model",
    "rna_fragmentation": "RNA Fragmentation",
    "enrichment": "RNA Enrichment",
    "library_protocol": "Library Protocol",
    "read_mode": "Read Mode",
    "reference": "Reference",
    "alignment_software": "Alignment Software",
    "quantification_tool": "Quantification Tool",
    "expression_unit": "Expression Unit",
    "determinated_at": "Sequencing Date",
    "meta_file": "Meta File",
    "exp_file": "Expression File",
    "count_file": "Count File",
    "acoustic_shear": "Acoustic Shear",
    "enzymatic": "Enzymatic",
    "chemical": "Chemical/Heat",
    "no_fragmentation": "No Fragmentation",
    "ribosomal_depletion": "Ribosomal RNA Depletion",
    "polyA_selection": "Poly-A Selection",
    "total_rna": "Total RNA",
    "globin_depletion": "Globin Depletion",
    "targeted_capture": "Targeted Capture"
  },
  "protein": {
    "edit_data": "Edit Protein Data",
    "add_data": "Add Protein Data",
    "view_data": "View Protein Data",
    "name": "Name",
    "ms_instrument": "MS Instrument",
    "acquisition_method": "Acquisition Method",
    "lc_system": "LC System",
    "lc_column": "LC Column",
    "fractionation": "Fractionation",
    "digestion_enzyme": "Digestion Enzyme",
    "analysis_software": "Analysis Software",
    "database": "Database",
    "normalization": "Normalization",
    "determinated_at": "Measurement Date",
    "meta_file": "Meta File",
    "exp_file": "Expression File",
    "no_fractionation": "No Fractionation",
    "high_ph_reverse_phase": "High-pH Reverse Phase",
    "scx": "SCX",
    "gelc_ms": "GeLC-MS"
  },
  "metabolism": {
    "edit_data": "Edit Metabolism Data",
    "add_data": "Add Metabolism Data",
    "view_data": "View Metabolism Data",
    "name": "Name",
    "ms_instrument": "MS Instrument",
    "detection_strategy": "Detection Strategy",
    "analysis_platform": "Analysis Platform",
    "chromatography": "Chromatography",
    "ionization": "Ionization & Polarity",
    "extraction_method": "Extraction Method",
    "preprocessing_software": "Preprocessing Software",
    "identification_level": "Identification Level",
    "unit": "Unit & Normalization",
    "database": "Database",
    "determinated_at": "Measurement Date",
    "meta_file": "Meta File",
    "exp_file": "Expression File",
    "untargeted": "Untargeted",
    "targeted": "Targeted",
    "semi_targeted": "Semi-targeted",
    "lipidomics": "Lipidomics",
    "lc_ms": "LC-MS",
    "gc_ms": "GC-MS",
    "nmr": "NMR",
    "ce_ms": "CE-MS",
    "di_ms": "DI-MS",
    "reverse_phase": "Reverse Phase",
    "hilic": "HILIC",
    "normal_phase": "Normal Phase",
    "gc_capillary_column": "GC-Capillary Column",
    "ion_exchange": "Ion Exchange",
    "esi_positive": "ESI Positive",
    "esi_negative": "ESI Negative",
    "apci": "APCI",
    "ei": "EI",
    "name_version": "Database name & version"
  },
  "plasmix_protein": {
    "edit_data": "Edit Protein Data",
    "add_data": "Add Protein Data",
    "view_data": "View Protein Data",
    "name": "Name",
    "technology": "Technology",
    "model_panel": "Model Panel",
    "pre_treatment": "Pre-treatment",
    "readout": "Readout",
    "protocol": "Protocol",
    "expression_unit": "Expression Unit",
    "analysis_software": "Analysis Software",
    "database": "Database",
    "normalization": "Normalization",
    "determinated_at": "Measurement Date",
    "meta_file": "Meta File",
    "exp_file": "Expression File",
    "neat_plasma": "Neat Plasma",
    "high_abundance_depletion": "High-Abundance Depletion",
    "nanoparticle_enrichment": "Nanoparticle Enrichment",
    "proximity_extension": "Proximity Extension",
    "aptamer_capture": "Aptamer Capture"
  },
  "plasmix_metabolism": {
    "edit_data": "Edit Metabolism Data",
    "add_data": "Add Metabolism Data",
    "view_data": "View Metabolism Data",
    "name": "Name",
    "ms_instrument": "MS Instrument",
    "detection_strategy": "Detection Strategy",
    "analysis_platform": "Analysis Platform",
    "chromatography": "Chromatography",
    "ionization": "Ionization & Polarity",
    "extraction_method": "Extraction Method",
    "preprocessing_software": "Preprocessing Software",
    "normalization": "Normalization",
    "identification_basis": "Identification Basis",
    "database": "Database",
    "determinated_at": "Measurement Date",
    "meta_file": "Meta File",
    "exp_file": "Expression File",
    "untargeted": "Untargeted",
    "targeted": "Targeted",
    "polar_metabolites": "Polar Metabolites",
    "lipidomics": "Lipidomics",
    "lc_ms": "LC-MS",
    "gc_ms": "GC-MS",
    "nmr": "NMR",
    "di_ms": "DI-MS",
    "reverse_phase": "Reverse Phase",
    "hilic": "HILIC",
    "normal_phase": "Normal Phase",
    "gc_capillary_column": "GC-Capillary Column",
    "biphasic": "Biphasic/Mixed-mode",
    "esi_positive": "ESI Positive",
    "esi_negative": "ESI Negative",
    "apci": "APCI",
    "ei": "EI",
    "dual_polarity": "Dual Polarity",
    "name_version": "Database name & version"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "theme": "Theme",
    "preferences": "Preferences",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore",
    "active": "Active",
    "inactive": "Inactive",
    "role": "Role",
    "notes": "Notes",
    "add_user": "Add User",
    "edit_user": "Edit User",
    "save": "Save",
    "add": "Add",
    "leave_empty_unchanged": "Leave empty to keep unchanged",
    "confirm_form_change_disregard": "Form has unsaved changes. Are you sure you want to close it?",
    "confirm_enable_access_key": "Are you sure to enable the Aliyun account?",
    "confirm_disable_access_key": "Are you sure to disable the Aliyun account?"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "supportAndConsulting": "Support & Consulting",
  "search": {
    "placeholder": "Search or add a new option"
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go previous slide",
    "goNextSlide": "go next slide",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option",
    "no_items": "No items",
    "total_results": "Total {value} results",
    "results_per_page": "Results per page"
  }
}
